import { nanoid } from 'nanoid';
import React, { Component } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MultiStage from '../../../CreateApplet/MultiStage';
import Responsive from '../../../../components/Responsive';
import { getBoundingClientRect } from '../../../../utils/functions';
import { translate } from '../../../../utils/useful';
import ButtonAnimated from '../../../../components/buttons/ButtonAnimated';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../stores/actionsList';
import HttpServices from '../../../../utils/Http.services';

class CollectionStage extends Component {

    state = {
        defaultStage: [{ id: `${nanoid()}` }],
        actionList: [
            { title: '{{lang}}Success', key: 'success', icon: "/assets/icons/hand.thumbsup.fill.svg" },
            { title: '{{lang}}Stuck', key: 'stuck', icon: "/assets/icons/hand.raised.fill.svg" },
            { title: '{{lang}}Cancel', key: 'cancell', icon: "/assets/icons/hand.thumbsdown.fill.svg" },
            { title: '{{lang}}Needs', key: 'needs', icon: "/assets/icons/rectangle.and.hand.point.up.left.fill.svg" },
            { title: '{{lang}}Archive', key: 'archive', icon: "/assets/icons/folder.fill.badge.person.crop.svg" }
        ],
        data: {},
        name: null,
        isLoadingData: false,
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.state.isLoadingData ? () => { } : () => this.nextStage()}
                    // onClick={this.state.isLoadingData ? () => { } : () => this.saveProject()}
                    title='Next'
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    isLoading={this.state.isLoadingData}
                />
            </div>
        )
    }


    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert view name ...')} />
            </div>
        )
    }

    componentDidMount() {
        if (this.props.initData?.collectionInfo?.automations) {
            this.setState({ defaultStage: this.props.initData?.collectionInfo?.automations })
            console.log('defaultStage', this.props.initData?.collectionInfo?.automations)
        }
        if (this.props.setHeader) {
            let object = {
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                // headerIdentityComponent: this.headerIdentityComponent,
                // backAction: () => this.props.changePage()
                backAction: () => this.props.changeStage('collectionType')
            }
            console.log('this.props.headerIdentityComponent',this.props.headerIdentityComponent)
            if (this.props.headerIdentityComponent) {
                object.headerIdentityComponent = this.props.headerIdentityComponent
            }else{
                object.headerIdentityComponent = this.headerIdentityComponent

            }
            console.log('objectlsls',object)
            this.props.setHeader(object)
        }
    }

    componentWillUnmount() { }

    setName = (value) => {
        console.log('nameeeeeeeee', value)
        this.setState({ name: value }, () => {
        })
    }

    saveProject = () => {
        console.log('1')
        let defaultStage = this.state.defaultStage
        console.log('2', defaultStage)
        let initData = this.props.initData
        this.setState({ isLoadingData: true })
        if (this.state.name?.trim() == null || !this.state.name?.trim()) {
            this.setState({ name: null }, () => {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: '{{lang}}errors.NameRequired' })
                this.setState({ isLoadingData: false })
            })
        }
        if (defaultStage.length == 0) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty', description: '{{lang}}errors.ContentEmpty' })
            this.setState({ isLoadingData: false })
        }
        if (this.state.name && this.state.name.trim() != null && defaultStage.length != 0) {
            let data = { collectionInfo: { automations: [] } }
            data.collectionInfo.automations = defaultStage
            data.name = this.state.name
            data.type = 'collection'
            data.applet = this.props.variables.appletId
            HttpServices.request('postProject', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    console.log('fetcherr', fetchError)
                    return
                }
                console.log('fetres', fetchResult)
                this.nextStage()
            })
        }
    }

    nextStage = (rawData) => {
        let data = this.props.initData
        if (!data.collectionInfo) {
            data.collectionInfo = {}
        }
        data.collectionInfo.automations = this.state.defaultStage
        console.log('setnex')
        this.props.setData('data', data, 'CollectionBuilder', () => {
            console.log('firstcollectionPermissions')
            this.props.changeStage('collectionPermissions')
        })
        this.setState({ isLoadingData: false })
    }

    onDragEnd = (result) => {
        let items = Array.from(this.state.defaultStage);
        let [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);
        this.setState({ defaultStage: items }, () => {
        });
    };

    // selectHandler = (item) => {
    //     let defaultt = this.state.defaultStage;
    //     defaultt.push(item);
    //     this.makeList()
    //     this.setState({ defaultStage: defaultt }, this.createStage.hideView());
    // };
    // makeList = () => {
    //     let defaultt = this.state.defaultStage
    //     let stages = []
    //     this.props.headers.forEach(e => {
    //         if (!defaultt.includes(e)) {
    //             if (!stages.includes(e)) {
    //                 stages.push(e)

    //             }
    //         }
    //     });
    //     this.setState({ stages })

    // }
    // submitSage = () => {
    //     let form = this.form.getForm()
    //     console.log('form', form)
    //     let defaultStage = this.state.defaultStage
    //     let id = nanoid()
    //     defaultStage.push({ id: `${id}`, name: form.stageName, type: form.stageType })

    //     this.setState({ defaultStage, stageName: '' })
    // }

    addStage = () => {
        let defaultStage = this.state.defaultStage
        defaultStage.push({ id: `${nanoid()}` })
        this.setState({ defaultStage })
    }

    changeValue = (event, index) => {
        let defaultStage = this.state.defaultStage
        defaultStage[index].name = event.target.value
        this.setState({ defaultStage })
    }

    // setData = (key, value) => {
    //     let defaultt = this.state.defaultStage
    //     for (let i = 0; i < defaultt.length; i++) {
    //         if (defaultt[i].id == key.id) {
    //             defaultt.splice(i, 1, value)
    //             break
    //         }
    //     }
    //     this.setState({ defaultStage: defaultt })

    // }

    addActions = (key, index) => {
        let defaultStage = this.state.defaultStage
        defaultStage[index].type = key
        this.setState({ defaultStage })
    }

    removeItem(index) {
        // Create a copy of the actionList array
        const defaultStage = [...this.state.defaultStage];

        // Remove the item at the specified index
        defaultStage.splice(index, 1);

        // Update the state with the modified actionList
        this.setState({ defaultStage });
    }

    render() {
        return (
            <div className='h-100 w-100 window-content-radius bg-white flexcc' style={{}}>
                {/* <div className='w-100 h-100 position-absolute overflow-hidden'>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>
                    </div>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>
                    </div>
                </div> */}
                <div className='p-3 position-relative h-100' style={{ maxWidth: 600 }}>
                    <div className=''>
                        <p className='font-size-18 weight-500 main-text1'>{translate('The text blow Title')}</p>
                        <p className='mt-1 font-size-13' style={{ color: "#888" }}>{translate('text-below-title-description')}</p>
                    </div>
                    <div className='px-2 py-3 br-15 mt-3 w-100' style={{ background: "#c1d5ff", height: 'calc(100% - 120px)' }}>
                        <div className='d-flex mx-4' style={{ justifyContent: "end" }}>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.addStage}
                                title={translate("ca.Add Stage")}
                                icon='/assets/icons/plus-white.svg'
                                textColor={'#fff'}
                                bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                            />
                        </div>
                        <div className="flexc mb-3 br-20 w-100 sc-gray2" style={{ flexDirection: "column", alignItems: "center", height: 'calc(100% - 30px)', overflow: 'auto' }}>
                            <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                                <Droppable droppableId="droppable">
                                    {(provided) => (
                                        <div className=" h-100" style={{}} {...provided.droppableProps} ref={provided.innerRef}>
                                            {this.state.defaultStage.map((item, index) => {
                                                return (
                                                    <div key={item.id}>
                                                        <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
                                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                                            {(provided, snapshot) => {
                                                                if (snapshot.isDragging) {
                                                                    if (!provided.draggableProps) {
                                                                        provided.draggableProps = { style: { zIndex: "999" } };
                                                                    }
                                                                    let bound = getBoundingClientRect(this.setPositionDiv.current);
                                                                    const offset = { x: bound.left, y: bound.top };
                                                                    // console.log(offset.x, offset.y)
                                                                    const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                    const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                    // console.log("y:", y, "x:", x);
                                                                    provided.draggableProps.style.left = x;
                                                                    provided.draggableProps.style.top = y;
                                                                    provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                    provided.draggableProps.style.zIndex = "999";
                                                                    provided.draggableProps.style.borderRadius = "10px"
                                                                }
                                                                return (
                                                                    <>
                                                                        <div style={{ width: 200, height: 200, }} className="flexcb mt-3 br-10 bg-white" ref={provided.innerRef} {...provided.draggableProps} >
                                                                            <div className='mld-4' {...provided.dragHandleProps}>
                                                                                <img className='flexcc' src='/assets/icons/dragicon.svg' />
                                                                            </div>
                                                                            <MultiStage index={index} changeValue={this.changeValue} addActions={this.addActions} data={item} actionList={this.state.actionList} />
                                                                            <button className="px-2" onClick={() => this.removeItem(index)}>
                                                                                <img className="flexcc opacity-hover" src="/assets/icons/trash-red.svg" />
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                );
                                                            }}
                                                        </Draggable>
                                                    </div>
                                                );
                                            })}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CollectionStage);